import Input from '../../../components/Input/Input';
import { useState } from 'react';

const AutoTopUpInput = ({
  value,
  onChange,
  label,
}: {
  value: number | undefined;
  onChange: (val: number) => void;
  label: string;
}) => {
  const [inputFocus, setInputFocus] = useState(false);

  return (
    <div className="items-left flex flex-col justify-start gap-1 rounded-[1.5em]">
      <p className={`modal-text !text-xs ${inputFocus && '!text-ph-primary-violet'}`}>{label}</p>
      <Input
        type="number"
        fullWidth
        autoComplete="off"
        onFocus={() => setInputFocus(true)}
        onBlur={() => setInputFocus(false)}
        onChange={(e) => onChange(Number(e.target.value))}
        value={value?.toString()}
        className={`!border !border-solid text-white ${inputFocus ? '!border-[#a958d7]' : 'border-[#ffffff80]'}`}
      />
    </div>
  );
};

export default AutoTopUpInput;
